import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../service/caller';
import '../../../assets/css/mainstyle.css'
import { ToastContainer, toast } from 'react-toastify';
import imageOrangeTopLeft from '../../../assets/images/Medic symbol circle.png';
import imageOrangeBottomLeft from '../../../assets/images/Checklist.png';
import imageOrangeBottomright from '../../../assets/images/DNA.png';
import BottomLeftmedication from '../../../assets/images/Pil.png';
import logomedtinz from '../../../assets/images/MedTinz.png';
import '../login.css';


const FirstLoginPasswordChange = () => {
    const [UserData, setUserData] = useState([]);
    const [form, setForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        otp: ''
    });
    const [otpSent, setOtpSent] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);

                if (response.data.firstlogin) {
                    return;
                } else {
                    navigate('/hospitaladmin/dashboard');
                }
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, [navigate]);

    const handleRequestOtp = async (e) => {
        e.preventDefault();

        if (form.newPassword !== form.confirmPassword) {
            return toast.error("Les mots de passe ne correspondent pas.");
        }

        try {
            await api.post('/api/users/request-password-change', {
                currentPassword: form.currentPassword,
                newPassword: form.newPassword
            });
            toast.success("Code OTP envoyé à votre email.");
            setOtpSent(true);
        } catch (err) {
            toast.error(err.response?.data?.message || "Erreur lors de la requête OTP");
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        try {
            await api.post('/api/users/verify-otp-password-change', {
                otp: form.otp
            });
            toast.success("Mot de passe modifié avec succès !");
            setTimeout(() => {
                navigate('/hospitaladmin/dashboard');
            }, 2000);
        } catch (err) {
            toast.error(err.response?.data?.message || "Erreur de validation du code OTP");
        }
    };

    return (
        <>
            <ToastContainer />
            <section className='py-5 position-relative' style={{ background: '#0056B3' }}>
                <div className='container px-4 mt-5'>
                    <div className='row text-center'>
                        <div className='col-lg-3 mb-3'>
                            <div className='mt-2'>
                                <img src={logomedtinz} alt="Bottom left orange" className="logomedtinz" />
                            </div>
                        </div>
                        <div className='col-lg-6 mb-3'>
                            <h2 className='text-white text-center' style={{ fontSize: '45px', fontFamily: 'Inter,sans-serif', fontWeight: '600' }}>Connect Now To Your Dashboard</h2>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div style={{ width: '66%' }}>
                        </div>
                    </div>
                </div>
                <div style={{ position: 'absolute', right: '0', top: '0' }}>
                    <img src={imageOrangeTopLeft} />

                </div>
                <div style={{ position: 'absolute', left: '0', bottom: '-5rem' }}>
                    <img src={imageOrangeBottomLeft} />
                </div>
            </section>
            <section className='mt-5 container position-relative px-4'>
                <div className='row mt-5'>
                    <div className='col-md-6 mb-3 py-4 mx-auto'>
                        <div className="text-center mb-5">
                            <h4 className="fw-bold">Enter your credentials</h4>
                        </div>
                        {!otpSent ? (
                            <form onSubmit={handleRequestOtp}>
                                <div className="form-floating mb-3">
                                    <input
                                        type="password"
                                        className="form-control padi"
                                        id="email"
                                        style={{ border: '3px solid #0056B3' }}
                                        placeholder="Mot de passe actuel"
                                        value={form.currentPassword}
                                        onChange={e => setForm({ ...form, currentPassword: e.target.value })}
                                        required
                                    />
                                    <label htmlFor="email" className='pad'>Mot de passe actuel</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input
                                        type="password"
                                        className="form-control padi"
                                        id="email"
                                        style={{ border: '3px solid #0056B3' }}
                                        placeholder="Nouveau mot de passe"
                                        value={form.newPassword}
                                        onChange={e => setForm({ ...form, newPassword: e.target.value })}
                                        required
                                    />
                                    <label htmlFor="email" className='pad'>Nouveau mot de passe</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input
                                        type="password"
                                        className="form-control padi"
                                        id="email"
                                        style={{ border: '3px solid #0056B3' }}
                                        placeholder="Confirmer le mot de passe"
                                        value={form.confirmPassword}
                                        onChange={e => setForm({ ...form, confirmPassword: e.target.value })}
                                        required
                                    />
                                    <label htmlFor="email" className='pad'>Confirmer le mot de passe</label>
                                </div>
                                <button
                                    className="btn btn-primary w-100 py-3 fw-bold text-white"
                                    style={{ backgroundColor: '#0056b3', borderColor: '#0056b3' }}
                                >
                                    Envoyer OTP <span className="ms-1">→</span>
                                </button>
                            </form>
                        ) : (
                            <form onSubmit={handleVerifyOtp}>
                                <div className="form-floating mb-3">
                                    <input
                                        type="number"
                                        className="form-control padi"
                                        id="email"
                                        style={{ border: '3px solid #0056B3' }}
                                        placeholder="Code OTP"
                                        value={form.otp}
                                        onChange={e => setForm({ ...form, otp: e.target.value })}
                                        required
                                    />
                                    <label htmlFor="email" className='pad'>Code OTP</label>
                                </div>
                                <button
                                    className="btn btn-success w-100 py-3 fw-bold text-white"
                                    style={{ backgroundColor: '#0056b3', borderColor: '#0056b3' }}
                                >
                                    Valider le changement <span className="ms-1">→</span>
                                </button>
                            </form>
                        )}
                    </div>

                </div>

                <div className='d-none d-lg-block'>
                    <div style={{ position: 'absolute', top: '80%', left: '83%' }}>
                        <img src={imageOrangeBottomright} />
                    </div>
                </div>

                <div className='img4'>
                    <p>© 2024 | Développé par ITTIQ </p>
                </div>
            </section>
        </>
    );
};

export default FirstLoginPasswordChange;
